/**
 * Filter accordion: expand/collapse of the filter panel and closing it on an
 * outside click/tap. Extracted verbatim from the globe client monolith
 * (Phase 3). Returns a `collapseIfExpanded` helper so the view toggle and table
 * filter can collapse the panel when they take over.
 */
/* eslint-disable */
export interface FilterAccordionApi {
  collapseIfExpanded: () => void
}

export function initFilterAccordion(): FilterAccordionApi {
    var filterToggle = document.getElementById('filter-toggle');
    var filterContent = document.getElementById('filter-content');
    var filterExpandBtn = document.getElementById('filter-expand-btn');

    function collapseFilterContentIfExpanded() {
      if (!filterContent || filterContent.classList.contains('collapsed')) return;
      filterContent.classList.remove('expanded');
      filterContent.classList.add('collapsed');
      if (filterExpandBtn) filterExpandBtn.classList.remove('rotated');
    }

    if (filterToggle) {
      filterToggle.addEventListener('click', function(e) {
        if ((e.target as Element).closest('#filter-view-toggle')) return;
        if (!filterContent) return;
        var isCollapsed = filterContent.classList.contains('collapsed');

        if (isCollapsed) {
          // Expand
          filterContent.classList.remove('collapsed');
          filterContent.classList.add('expanded');
          if (filterExpandBtn) filterExpandBtn.classList.add('rotated');
        } else {
          // Collapse
          filterContent.classList.remove('expanded');
          filterContent.classList.add('collapsed');
          if (filterExpandBtn) filterExpandBtn.classList.remove('rotated');
        }
      });
    }

    // Close filter dropdown when clicking/tapping outside of it
    function closeFilterOnOutsideEvent(e) {
      if (!filterContent || filterContent.classList.contains('collapsed')) return;
      var filterSection = document.getElementById('filter-section');
      if (filterSection && !filterSection.contains(e.target)) {
        collapseFilterContentIfExpanded();
      }
    }
    document.addEventListener('click', closeFilterOnOutsideEvent);
    document.addEventListener('mousedown', closeFilterOnOutsideEvent);
    document.addEventListener('touchstart', closeFilterOnOutsideEvent);

    return { collapseIfExpanded: collapseFilterContentIfExpanded };
}
